import React from 'react';

import { Dialog, DialogContent } from '@mui/material';

type AuditLogDialogProps = {
  open: boolean;
  content: React.ReactNode;
  handleOnClose: () => void;
};

const AuditLogDialog = ({
  open,
  handleOnClose,
  content,
}: AuditLogDialogProps) => (
  <Dialog
    open={open}
    onClose={handleOnClose}
    aria-labelledby="alertTitle"
    aria-describedby="alertContent"
  >
    <DialogContent id="alertContent">
      <div className="min-w-[400px]">{content}</div>
    </DialogContent>
  </Dialog>
);

export default AuditLogDialog;
